import { Component, inject, Input } from '@angular/core';
import { ProgramFormComponent } from '../program-form.component';
import { ButtonModule } from '@ui/form/button/button.module';
import { ButtonRowModule } from '@ui/form/button-row/button-row.module';
import { CalendarControlModule } from '@ui/form/calendar-control/calendar-control.module';
import { FormGroupWrapperModule } from '@ui/form/form-group-wrapper/form-group-wrapper.module';
import { FormInputComponent } from '@ui/form/form-input/form-input.component';
import { FormSelectComponent } from '@ui/form/form-select/form-select.component';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ProgramNumberOfTripsFormField, ProgramNumberOfTripsFormService } from './program-number-of-trips-form.service';
import { PartnerProgram } from '@api/models/B2bService/Contract/partner-program';
import {
    ParseB2bProgramTicketsNamePipe,
} from '../../../../shared/pipes/parse-b2b-program-tickets-name/parse-b2b-program-tickets-name.pipe';
import { B2bProgramType } from '../../../../shared/models/b2b-program-type';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'b2b-program-number-of-trips-form',
    imports: [
        ButtonModule,
        ButtonRowModule,
        CalendarControlModule,
        FormGroupWrapperModule,
        FormInputComponent,
        FormSelectComponent,
        FormsModule,
        NgSelectComponent,
        ReactiveFormsModule,
        ParseB2bProgramTicketsNamePipe,
        TranslatePipe,
    ],
    templateUrl: './program-number-of-trips-form.component.html',
    styleUrl: './program-number-of-trips-form.component.scss',
    providers: [ProgramNumberOfTripsFormService],
})
export class ProgramNumberOfTripsFormComponent extends ProgramFormComponent {
    readonly #programNumberOfTripsFormService: ProgramNumberOfTripsFormService = inject(ProgramNumberOfTripsFormService);

    protected readonly programNumberOfTripsFormField: typeof ProgramNumberOfTripsFormField = ProgramNumberOfTripsFormField;
    protected readonly b2bProgramTypeEnum: typeof B2bProgramType = B2bProgramType;

    constructor() {
        super();

        this.form = this.#programNumberOfTripsFormService.createReactiveForm();
    }

    public override get trfId(): AbstractControl {
        return this.form.get(ProgramNumberOfTripsFormField.TrfIdArr);
    }

    public get prgTypeValue(): B2bProgramType {
        return this.form.get(ProgramNumberOfTripsFormField.PrgType)?.value;
    }

    /**
     * B2b program data for form fill
     */
    @Input()
    public set b2bProgram(b2bProgram: PartnerProgram) {
        if (b2bProgram) {
            const { prgName, trfName, orgName }: Partial<PartnerProgram> = b2bProgram;
            this.trfName = trfName;
            this.prtName = orgName;

            this.form.patchValue({
                ...b2bProgram,
                name: prgName,
            });

            this.#programNumberOfTripsFormService.getControlByPath(ProgramNumberOfTripsFormField.TrfIdArr).clearValidators();
        }
    }

    public handlerAdd(): void {
        this.submitForm.emit(this.form.getRawValue());
    }

    public handlerEdit(): void {
        this.submitForm.emit({
            ...this.form.getRawValue(),
            prgId: this.prgId,
        });
    }
}
